export const CONST_HASH_MAIN_DASHBOARD = '%242y%2410%24sj.IhVFId7qTm4r9k2.oeOgqOStOhlw2KLODKRmjAJggGcrnH20qm';
